// extracted by mini-css-extract-plugin
export default {"breadCrumbMain":"BreadCrumb_breadCrumbMain__yb4gy","breadcrumbList":"BreadCrumb_breadcrumbList__nckRH","crumb":"BreadCrumb_crumb__wzi9Q"};